import axios from 'axios';

export default async function approveShuttleMission(baseUrl, payload){
  try{
    const res = await axios.post(`${baseUrl}/admin/approveShuttleMission`, payload);
    return res.data || res;
  }catch(e){
    return 'error';
  }
}
